import { default as api_45logsQwDTCVuK8sMeta } from "/opt/buildhome/repo/pages/api-logs.vue?macro=true";
import { default as api_45testerP2viGkoBm6Meta } from "/opt/buildhome/repo/pages/api-tester.vue?macro=true";
import { default as apimKruMht4aSMeta } from "/opt/buildhome/repo/pages/api.vue?macro=true";
import { default as authdjl0VO0QO1Meta } from "/opt/buildhome/repo/pages/auth.vue?macro=true";
import { default as billingi84s02FJFOMeta } from "/opt/buildhome/repo/pages/billing.vue?macro=true";
import { default as contactupLWW5VsuQMeta } from "/opt/buildhome/repo/pages/contact.vue?macro=true";
import { default as dashboard6cxkiptQlsMeta } from "/opt/buildhome/repo/pages/dashboard.vue?macro=true";
import { default as downloaderNYzEtMQDDCMeta } from "/opt/buildhome/repo/pages/downloader.vue?macro=true";
import { default as indexniDiYCWjuTMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as logsf8yw9QQw8vMeta } from "/opt/buildhome/repo/pages/logs.vue?macro=true";
import { default as multi_45downloaderpdH0dgAB32Meta } from "/opt/buildhome/repo/pages/multi-downloader.vue?macro=true";
import { default as playlist_45downloaderpkKNpfeVRDMeta } from "/opt/buildhome/repo/pages/playlist-downloader.vue?macro=true";
import { default as preferenceLEPtWeYBEuMeta } from "/opt/buildhome/repo/pages/preference.vue?macro=true";
import { default as updateqDcvL67VWnMeta } from "/opt/buildhome/repo/pages/profile/update.vue?macro=true";
import { default as region_45checker37Fm51pL7uMeta } from "/opt/buildhome/repo/pages/region-checker.vue?macro=true";
import { default as settings4cDYwTsA31Meta } from "/opt/buildhome/repo/pages/settings.vue?macro=true";
import { default as youtube_45toolslMsGhMDHp6Meta } from "/opt/buildhome/repo/pages/youtube-tools.vue?macro=true";
export default [
  {
    name: "api-logs",
    path: "/api-logs",
    component: () => import("/opt/buildhome/repo/pages/api-logs.vue")
  },
  {
    name: "api-tester",
    path: "/api-tester",
    component: () => import("/opt/buildhome/repo/pages/api-tester.vue")
  },
  {
    name: "api",
    path: "/api",
    component: () => import("/opt/buildhome/repo/pages/api.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: authdjl0VO0QO1Meta || {},
    component: () => import("/opt/buildhome/repo/pages/auth.vue")
  },
  {
    name: "billing",
    path: "/billing",
    component: () => import("/opt/buildhome/repo/pages/billing.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/opt/buildhome/repo/pages/dashboard.vue")
  },
  {
    name: "downloader",
    path: "/downloader",
    component: () => import("/opt/buildhome/repo/pages/downloader.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexniDiYCWjuTMeta || {},
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "logs",
    path: "/logs",
    component: () => import("/opt/buildhome/repo/pages/logs.vue")
  },
  {
    name: "multi-downloader",
    path: "/multi-downloader",
    component: () => import("/opt/buildhome/repo/pages/multi-downloader.vue")
  },
  {
    name: "playlist-downloader",
    path: "/playlist-downloader",
    component: () => import("/opt/buildhome/repo/pages/playlist-downloader.vue")
  },
  {
    name: "preference",
    path: "/preference",
    component: () => import("/opt/buildhome/repo/pages/preference.vue")
  },
  {
    name: "profile-update",
    path: "/profile/update",
    meta: updateqDcvL67VWnMeta || {},
    component: () => import("/opt/buildhome/repo/pages/profile/update.vue")
  },
  {
    name: "region-checker",
    path: "/region-checker",
    component: () => import("/opt/buildhome/repo/pages/region-checker.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/opt/buildhome/repo/pages/settings.vue")
  },
  {
    name: "youtube-tools",
    path: "/youtube-tools",
    component: () => import("/opt/buildhome/repo/pages/youtube-tools.vue")
  }
]